module.exports = __webpack_public_path__ + "static/media/1.Book.9f67a2a5.jpg";